import { KTIcon } from "../../../../_metronic/helpers";

const PromoCycleModalHeader = ({
  setOpenPromoCycleModal,
  setPromoCycleId
}) => {
  return (
    <div className="modal-header">
      {/* begin::Modal title */}
      <div>
      <h2 className="fw-bolder">{`All Promo Cycles`}</h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary"
        data-kt-users-modal-action="close"
        onClick={() => {
          setOpenPromoCycleModal(false);
          setPromoCycleId(null);
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
      {/* end::Close */}
    </div>
  );
};

export { PromoCycleModalHeader };
